import cancellationPortal from '@cancellation-portal/internationalization/localization-messages/CancellationPortal/es-US.json';
import cancellationPortalAgencyAgreement from '@cancellation-portal/internationalization/localization-messages/cancellations/cancellation-portal/cancellation-portal-agency-agreement/es-US.json';

export const esUSTranslations = {
  CancellationPortal: cancellationPortal,
  'cancellations/cancellation-portal/cancellation-portal-agency-agreement': cancellationPortalAgencyAgreement,
};
